var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.rulesValue},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-file-input',{attrs:{"error-messages":errors,"value":_vm.value,"rounded":"","filled":"","chips":"","show-size":"","type":"file","accept":_vm.acceptValue,"label":_vm.label},on:{"change":_vm.selected}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }